// Correos autorizados para administrar las extensiones de vigencia del
// beneficio de cumpleaños (/validar-cumpleanos/extensiones).
export const BIRTHDAY_EXTENSION_EMAILS = [
  'jgal@mariaalmenara.pe',
  'xnunez@mariaalmenara.pe'
];

export const tieneAcceso = (email, allowedEmails) =>
  !!email && allowedEmails.some((allowed) => allowed.toLowerCase() === email.trim().toLowerCase());
